"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var dynamic_data_card_component_1 = __importDefault(require("../dynamic-data-card/dynamic-data-card.component"));
var ClubDistrictCards = function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var _j = (0, react_1.useState)((_c = (_b = (_a = props.clubs) === null || _a === void 0 ? void 0 : _a.find(function (c) {
      return c['is-primary'];
    })) === null || _b === void 0 ? void 0 : _b['club-guid']) !== null && _c !== void 0 ? _c : ''),
    selectedClubId = _j[0],
    setSelectedClubId = _j[1];
  var _k = (0, react_1.useState)((_f = (_e = (_d = props.districts) === null || _d === void 0 ? void 0 : _d.find(function (d) {
      return d['is-primary'];
    })) === null || _e === void 0 ? void 0 : _e['district-guid']) !== null && _f !== void 0 ? _f : ''),
    selectedDistrictId = _k[0],
    setSelectedDistrictId = _k[1];
  // Update district when club changes.
  (0, react_1.useEffect)(function () {
    var _a;
    if (!props.clubs || !props.districts) {
      return;
    }
    var selectedClub = (_a = props.clubs) === null || _a === void 0 ? void 0 : _a.find(function (c) {
      return c['club-guid'] === selectedClubId;
    });
    if (selectedClub && selectedClub['district-guid'] !== selectedDistrictId) {
      setSelectedDistrictId(selectedClub['district-guid']);
    }
  }, [selectedClubId]);
  // Update club when district changes.
  (0, react_1.useEffect)(function () {
    var _a, _b, _c;
    if (!props.clubs || !props.districts) {
      return;
    }
    var clubsInDistrict = (_a = props.clubs) === null || _a === void 0 ? void 0 : _a.filter(function (club) {
      return club['district-guid'] === selectedDistrictId;
    });
    if (clubsInDistrict === null || clubsInDistrict === void 0 ? void 0 : clubsInDistrict.map(function (c) {
      return c['club-guid'];
    }).includes(selectedClubId)) {
      return;
    }
    var primaryClubInDistrict = clubsInDistrict === null || clubsInDistrict === void 0 ? void 0 : clubsInDistrict.find(function (c) {
      return c['is-primary'];
    });
    var clubIdToSet = (_b = primaryClubInDistrict === null || primaryClubInDistrict === void 0 ? void 0 : primaryClubInDistrict['club-guid']) !== null && _b !== void 0 ? _b : (_c = clubsInDistrict === null || clubsInDistrict === void 0 ? void 0 : clubsInDistrict[0]) === null || _c === void 0 ? void 0 : _c['club-guid'];
    if (clubIdToSet) {
      setSelectedClubId(clubIdToSet);
    }
  }, [selectedDistrictId]);
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [props.clubs && (0, jsx_runtime_1.jsx)(dynamic_data_card_component_1.default, {
      metadataName: "clubs",
      state: [selectedClubId, setSelectedClubId],
      dataList: (_g = props.clubs) === null || _g === void 0 ? void 0 : _g.map(function (club) {
        return {
          id: club['club-guid'],
          isSelected: club['is-primary'],
          title: club['club-text'],
          link: {
            linkText: props.clubLinkText,
            linkUrl: club['club-url'],
            linkTarget: '_self'
          },
          textGroups: [{
            label: props.nextMeetingLabel,
            lines: club['next-meeting-details']
          }]
        };
      })
    }), props.districts && (0, jsx_runtime_1.jsx)(dynamic_data_card_component_1.default, {
      metadataName: "districts",
      state: [selectedDistrictId, setSelectedDistrictId],
      dataList: (_h = props.districts) === null || _h === void 0 ? void 0 : _h.map(function (district) {
        return {
          id: district['district-guid'],
          isSelected: district['is-primary'],
          title: district['district-text'],
          link: {
            linkText: props.districtLinkText,
            linkUrl: district['district-url'],
            linkTarget: '_self'
          },
          textGroups: [{
            label: props.districtLabel,
            lines: [district['district-number']]
          }, {
            label: props.zoneLabel,
            lines: [district['zone-number']]
          }]
        };
      })
    })]
  });
};
exports.default = ClubDistrictCards;